import { useContext } from 'react';
import { campaignFormContext } from 'context/CampaignFormContext';

export const useCampaignForm = () => useContext(campaignFormContext);
